import type {PackageResponseBody, TrimResponseBody} from '@dms/api/new-vehicle';

type TrimStatus = TrimResponseBody['publicationStatus'];

const isTrimOnline = (publicationStatus: TrimStatus | undefined) => publicationStatus === 'online';

/**
 * Whether an item of a published model year is in the price list the dealer receives, by its stored
 * or requested status, as the server decides it (PricelistMembership, D88): online trims, active
 * packages and the enabled Variants of online trims. A write of an item outside the price list
 * changes no price list content, so it needs no new pricelist version.
 */
export const isInPricelist = {
  trim: isTrimOnline,
  package: (status: PackageResponseBody['status']) => status === 'active',
  variant: (enabled: boolean, trimStatus: TrimStatus | undefined) =>
    enabled && isTrimOnline(trimStatus),
};
